require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-no-barbie-feet.json") })
        }
      }, "path---blog-no-barbie-feet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-no-barbie-feet!./.cache/json/blog-no-barbie-feet.json
// module id = 302
// module chunks = 231608221292675